export enum ReportType {
  ACFR= 'ACFR',
  PAFR= 'PAFR',
  AFR= 'AFR',
  BUDGET_BOOK= 'BUDGET_BOOK',
  QUARTERLY= 'QUARTERLY',
  MONTHLY= 'MONTHLY'
}
export enum SectionType {
  COVER_PAGE= 'COVER_PAGE',
  CONTENT_BLOCKS= 'CONTENT_BLOCKS',
  DIVIDER_PAGE= 'DIVIDER_PAGE',
  PDF= 'PDF',
  GENERAL='GENERAL',
  TOC= 'TOC',
  NOTE= 'NOTE'
}